import React from "react";

/**
 * TimeFormat component that formats time strings or date objects
 */
export const TimeFormat = ({
  date,
  formatOptions = {
    hour: "2-digit",
    minute: "2-digit",
  },
}) => {
  
  let dateObj;

  // Handle different date formats
  if (typeof date === "string") {
    // If it's just a time string like "14:00:00" without a date part
    if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(date)) {
      // Create a date object using today's date with the specified time
      const today = new Date();
      const [hours, minutes, seconds = 0] = date.split(":").map(Number);
      dateObj = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        hours,
        minutes,
        seconds
      );
    } else {
      // Try to parse as a regular date string
      dateObj = new Date(date);
    }
  } else if (date instanceof Date) {
    dateObj = date;
  } else {
    // Fallback for other types or invalid inputs
    dateObj = new Date();
  }

  // Check if the date is valid
  if (isNaN(dateObj.getTime())) {
    console.warn("Invalid date provided to TimeFormat:", date);
    return <span>--:--</span>;
  }

  try {
    const formattedTime = dateObj.toLocaleTimeString(
      localStorage.locale || "nl-NL",
      formatOptions
    );
    return <span>{formattedTime}</span>;
  } catch (error) {
    console.error("Error formatting time:", error);
    return <span>--:--</span>;
  }
};
